'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

var useExternalLink = require('../../../utilities/hooks/useExternalLink.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var MediaContactBlock = function MediaContactBlock(_ref) {
  var className = _ref.className,
      dividerBottom = _ref.dividerBottom,
      dividerTop = _ref.dividerTop;
  var classes = index$1['default']('list-block', 'lanl-media-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-media-block"
  }, /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "sidebar-header"
  }, "Contact"), /*#__PURE__*/React__default['default'].createElement(useExternalLink.GatsbyLink, {
    href: "tel:+1-505-667-7000",
    className: "phone"
  }, "(505) 667-7000"), /*#__PURE__*/React__default['default'].createElement("a", {
    className: "contact",
    href: "https://www.lanl.gov/newsroom/media-contacts/index.php"
  }, "Media contacts"));
};

MediaContactBlock.defaultProps = {
  dividerBottom: true,
  dividerTop: true
};
MediaContactBlock.propTypes = {
  className: index['default'].string,
  dividerBottom: index['default'].bool,
  dividerTop: index['default'].bool
};
exports.MediaContactBlock = MediaContactBlock;
exports['default'] = MediaContactBlock;